import React, { useState, useCallback, useContext, useEffect, useReducer, useRef } from 'react';
import { Modal, Button, Form, Tabs, Tab, Row, Col } from 'react-bootstrap';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
import { useTranslation } from "react-i18next";
import styles from './FileManager.module.css'
import FilesContainer from './FilesContainer';
import * as fileReq from '../../../axios/requests/filesReq'
import { sendSignatureDoc } from '../../../axios/requests/signatureReq';
import * as settings from '../../../settings'
import { getContactNameByConv } from '../../../util/functions'


const templateSelectedFilesOnTabs = {
    'All': [],
    'image': [],
    'document': [],
    'video': [],
    'audio': []
}

const initFileManagerState = {
    activeTab: 'All',
    selectedFilesOnCategory: templateSelectedFilesOnTabs,
    searchFielsInputValue: ''
}

const maxUploadFilesCount = settings.FILE_MAX_UPLOAD_COUNT || 5
const maxFileUploadSizeMB = settings.FILE_MAX_UPLOAD_SIZE_MB || 20

const fileManagerReducerFunc = (state, action) => {
    if (action.type === 'CHANGE_TAB') {
        return { ...state, activeTab: action.activeTab }
    }
    else if (action.type === 'SELECTED_FILES_ON_CATEGORY_CHANGED') {
        const newSelectedFilesOnCategory = JSON.parse(JSON.stringify(state.selectedFilesOnCategory))
        newSelectedFilesOnCategory[state.activeTab] = action.selectedFiles
        return { ...state, selectedFilesOnCategory: newSelectedFilesOnCategory }
    }
    else if (action.type === 'RESET_FILE_MANAGER') {
        return { ...state, selectedFilesOnCategory: templateSelectedFilesOnTabs }//initFileManagerState
    }
    else if (action.type === 'ON_CHANGE_SEARCH_FIELS_INPUT') {
        return { ...state, searchFielsInputValue: action.value }
    }
    return state
}
const FileManager = ({ mediaTokenData, onHide, permissionType, onAttachFilesClicked, onAttachFilesWithoutGalleryClicked, clientName, msgType, selectedConv, onGettingEncContainerUrl, settings, fileTypesLimit, fileCategoryLimit }) => {
    const [fileManager, fileManagerDispatch] = useReducer(fileManagerReducerFunc, initFileManagerState)
    const [showFileContainers, setShowFileContainers] = useState(true)
    const [showSpinnerManagerState, setShowSpinnerManagerState] = useState(true)
    const [searchDebounceTimeOutId, setSearchDebounceTimeOutId] = useState()
    const alertCtx = useContext(AlertContext)
    const [t] = useTranslation('common')
    const [fileExplorerOpenedForState, setfileExplorerOpenedForState] = useState('ONLY_ATTACH')//ONLY_ATTACH,ATTACH_TO_GALLERY
    const fileExplorer = useRef()

    const contactName = getContactNameByConv(selectedConv) || clientName
    const isDigitalSignSupported = settings.general?.isDigitalSignSupported

    useEffect(() => {
        if (fileCategoryLimit) {
            fileManagerDispatch({
                type: 'CHANGE_TAB',
                activeTab: fileCategoryLimit
            })
        }
        // setShowSpinnerManagerState(false)
    }, [fileCategoryLimit])

    const onNewTabSelectedHandler = useCallback((newTab) => {// [All,image,document,video,audio]
        if (newTab === 'signature') {
            if (!isDigitalSignSupported) {
                return alertCtx.showAlert(t('fail'), t('Please contact system administrator to enable the feature'), 'sm');
            }
        }
        fileManagerDispatch({
            type: 'CHANGE_TAB',
            activeTab: newTab
        })
    }, [])

    const onSelectFileHandler = useCallback((selectedFiles) => {
        fileManagerDispatch(
            {
                type: 'SELECTED_FILES_ON_CATEGORY_CHANGED',
                selectedFiles
            }
        )
    }, [])

    const onSendFilesClickedHandler = useCallback(async () => {
        console.log('onSendFilesClickedHandler')
        const attachedFiles = fileManager.selectedFilesOnCategory[fileManager.activeTab]
        onAttachFilesClicked(attachedFiles)
    }, [fileManager.selectedFilesOnCategory])

    const onAttachOneFileClickedHandler = useCallback(async (file) => {
        if (fileManager.activeTab === 'signature') {
            onSignatureDocAttachClickedHandler(file)
        }
        else {
            onAttachFilesClicked([file])
        }
    }, [fileManager.activeTab])

    const resetFileManager = useCallback(() => {
        if (fileExplorer?.current?.value) fileExplorer.current.value = null // Reset file explorer
        setShowFileContainers(false)
        setTimeout(async () => {
            fileManagerDispatch({
                type: 'RESET_FILE_MANAGER'
            })
            setShowFileContainers(true)
        }, 0)

    }, [])

    const uploadfile = useCallback(async (event) => {
        try {
            setShowSpinnerManagerState(true)
            event.preventDefault();
            const selectedFilesToUpload = [...event.target.files];

            // Check maximum file to upload selected
            if (selectedFilesToUpload?.length > maxUploadFilesCount) {
                throw new Error(t('A maximum of 5 files must be uploaded'))
            }

            // Cheack maximum upload size
            const tooBigFile = selectedFilesToUpload.find((uploadFile) => (uploadFile.size / 1024 / 1024) > maxFileUploadSizeMB)
            if (tooBigFile) {
                throw new Error(t('You can upload up to of file', { size: maxFileUploadSizeMB }))
            }

            //Upload files
            if (fileExplorerOpenedForState === 'ATTACH_TO_GALLERY') {
                for (const uploadFile of selectedFilesToUpload) {
                    await fileReq.uploadFile(uploadFile, true) //const uploadedFile = 
                }
                resetFileManager()//ONLY_ATTACH,ATTACH_TO_GALLERY
            }
            else if (fileExplorerOpenedForState === 'ONLY_ATTACH') {
                onAttachFilesWithoutGalleryClicked(selectedFilesToUpload)
            }
            else if (fileExplorerOpenedForState === 'ENC_FILES_CONTAINER') {

                const encContainer = await fileReq.createEncFilesContainer(clientName)
                const referenceKey = encContainer.referenceKey
                const fileId = encContainer.fileId
                let containerUrl
                for (let i = 0; i < selectedFilesToUpload.length; i++) {
                    const uploadFile = selectedFilesToUpload[i]
                    const isTheLastFile = i === selectedFilesToUpload.length - 1
                    if (isTheLastFile) {
                        containerUrl = await fileReq.addFilesToEncContainer(referenceKey, fileId, isTheLastFile, uploadFile)
                    }
                    else {
                        await fileReq.addFilesToEncContainer(referenceKey, fileId, isTheLastFile, uploadFile)
                    }
                }
                onGettingEncContainerUrl(containerUrl)
            }
        } catch (e) {
            alertCtx.showAlert(t('fail'), e.message, 'sm');
            setShowSpinnerManagerState(false)
            console.log(`fail to upload file=`, e)
        }
    }, [fileExplorerOpenedForState, clientName, onGettingEncContainerUrl])

    const onUploadFileBtnClicked = useCallback(() => {
        setfileExplorerOpenedForState('ATTACH_TO_GALLERY')
        fileExplorer.current.click()
    }, []);

    const onlyAttachBtnClicked = useCallback(() => {
        setfileExplorerOpenedForState('ONLY_ATTACH')
        fileExplorer.current.click()
    }, []);

    const onCreateFilesEncContainerHandler = useCallback(() => {
        if (isCreateEncContainerDisabled) {
            alertCtx.showAlert(t('fail'), t('Please contact system administrator to enable the feature'), 'sm');
        }
        else {
            setfileExplorerOpenedForState('ENC_FILES_CONTAINER')
            fileExplorer.current.click()
        }

    }, [])

    const onSignatureDocAttachClickedHandler = useCallback(async (signatureDetails) => {
        try {
            const { _id, signatureDataFields } = signatureDetails
            const sentSignDocDetails = await sendSignatureDoc(_id, clientName, msgType, contactName, signatureDataFields)
            const mainfillUrl = sentSignDocDetails.mainfillUrl
            onGettingEncContainerUrl(mainfillUrl)
        } catch (e) {
            alertCtx.showAlert(t('fail'), t('Error sending the digital signature'), 'sm');
        }
    }, [clientName, msgType, contactName, onGettingEncContainerUrl])

    const onSearchInputChange = useCallback((event) => {
        const newSearchInput = event.target.value
        fileManagerDispatch({
            type: 'ON_CHANGE_SEARCH_FIELS_INPUT',
            value: newSearchInput
        })
        const delaySearch = () => {
            setShowFileContainers(false)
            setTimeout(async () => {
                setShowFileContainers(true)
            }, 0)
        }
        if (searchDebounceTimeOutId) clearTimeout(searchDebounceTimeOutId)
        const searchTimeoutId = setTimeout(delaySearch, 500)
        setSearchDebounceTimeOutId(searchTimeoutId)
    }, [searchDebounceTimeOutId])

    const activeTabSelectedFilesCount = fileManager.selectedFilesOnCategory?.[fileManager.activeTab]?.length
    const isSupportedMsgTypeForFileContainer = msgType === 'whatsapp' || msgType === 'sms'
    const isCreateEncContainerDisabled = !settings?.channel?.isEncContainerSupported || !clientName || !isSupportedMsgTypeForFileContainer || !onGettingEncContainerUrl


    return (
        <>
            <Modal show={true} onHide={onHide} dialogClassName={`my-modal file-manager-modal`} size="xl" centered aria-labelledby="contained-modal-title-vcenter" className={`rtl-modal`} >
                <Modal.Header className={`${styles['file-manager-modal-header']}`}>
                    <Modal.Title>{t('gallery')} - {t(fileManager.activeTab)}</Modal.Title>
                    <section className={`${styles['search-files-main']}`}>
                        <div className={`${styles['search-files-container']}`}>
                            <input placeholder={t('search')} value={fileManager.searchFielsInputValue} onChange={onSearchInputChange} className={`${styles['search-files-input']}`} />
                            <i className={`fas fa-search fa-lg ${styles['search-icon']}`} />
                        </div>
                    </section>
                    {/* <div></div> */}
                </Modal.Header>
                <Modal.Body id='file-manager-model' className={`modal-body-style`} >
                    {/* <form onSubmit={onSubmitHandler}> */}
                    <Tabs id='file-manager-tabs' className={`cusTabs-contactlist open-contact-modal-tabs `} defaultActiveKey={fileCategoryLimit || 'All'} activeKey={fileManager.activeTab} onSelect={onNewTabSelectedHandler}>
                        {!fileCategoryLimit && <Tab className={`${styles['file-manager-tab']}`} tabClassName='details-tab tab-border' eventKey='All' title={`${t('All')}`}>
                            {showFileContainers && fileManager.activeTab === 'All' &&
                                <FilesContainer
                                    mediaTokenData={mediaTokenData}
                                    searchInput={fileManager.searchFielsInputValue}
                                    onSelectFile={onSelectFileHandler}
                                    tabKey={`All`}
                                    showSpinnerManagerState={showSpinnerManagerState}
                                    resetFileManager={resetFileManager}
                                    permissionType={permissionType}
                                    onAttachOneFileClicked={onAttachOneFileClickedHandler}
                                    fileTypesLimit={fileTypesLimit}
                                />}
                        </Tab>}
                        {(!fileCategoryLimit || fileCategoryLimit === 'image') && <Tab className={`${styles['file-manager-tab']}`} tabClassName='details-tab tab-border' eventKey='image' title={`${t('images')}`}>
                            {showFileContainers && fileManager.activeTab === 'image' &&
                                <FilesContainer
                                    mediaTokenData={mediaTokenData}
                                    searchInput={fileManager.searchFielsInputValue}
                                    onSelectFile={onSelectFileHandler}
                                    tabKey={`image`}
                                    fileCategory='image'
                                    showSpinnerManagerState={showSpinnerManagerState}
                                    resetFileManager={resetFileManager}
                                    permissionType={permissionType}
                                    onAttachOneFileClicked={onAttachOneFileClickedHandler}
                                    fileTypesLimit={fileTypesLimit}
                                />}
                        </Tab>}
                        {(!fileCategoryLimit || fileCategoryLimit === 'document') && <Tab className={`${styles['file-manager-tab']}`} tabClassName='details-tab tab-border' eventKey='document' title={`${t('documents')}`}>
                            {showFileContainers && fileManager.activeTab === 'document' &&
                                <FilesContainer
                                    mediaTokenData={mediaTokenData}
                                    searchInput={fileManager.searchFielsInputValue}
                                    onSelectFile={onSelectFileHandler}
                                    tabKey={`document`}
                                    fileCategory='document'
                                    showSpinnerManagerState={showSpinnerManagerState}
                                    resetFileManager={resetFileManager}
                                    permissionType={permissionType}
                                    onAttachOneFileClicked={onAttachOneFileClickedHandler}
                                    fileTypesLimit={fileTypesLimit}
                                />}
                        </Tab>}
                        {(!fileCategoryLimit || fileCategoryLimit === 'video') && <Tab className={`${styles['file-manager-tab']}`} tabClassName='details-tab tab-border' eventKey='video' title={`${t('videos')}`}>
                            {showFileContainers && fileManager.activeTab === 'video' &&
                                <FilesContainer
                                    mediaTokenData={mediaTokenData}
                                    searchInput={fileManager.searchFielsInputValue}
                                    onSelectFile={onSelectFileHandler}
                                    tabKey={`video`}
                                    fileCategory='video'
                                    showSpinnerManagerState={showSpinnerManagerState}
                                    resetFileManager={resetFileManager}
                                    permissionType={permissionType}
                                    onAttachOneFileClicked={onAttachOneFileClickedHandler}
                                    fileTypesLimit={fileTypesLimit}
                                />}
                        </Tab>}
                        {(!fileCategoryLimit || fileCategoryLimit === 'audio') && <Tab className={`${styles['file-manager-tab']}`} tabClassName='details-tab tab-border' eventKey='audio' title={`${t('audio')}`}>
                            {showFileContainers && fileManager.activeTab === 'audio' &&
                                <FilesContainer
                                    mediaTokenData={mediaTokenData}
                                    searchInput={fileManager.searchFielsInputValue}
                                    onSelectFile={onSelectFileHandler}
                                    tabKey={`audio`}
                                    fileCategory='audio'
                                    showSpinnerManagerState={showSpinnerManagerState}
                                    resetFileManager={resetFileManager}
                                    permissionType={permissionType}
                                    onAttachOneFileClicked={onAttachOneFileClickedHandler}
                                    fileTypesLimit={fileTypesLimit}
                                />}
                        </Tab>}
                        {((!fileCategoryLimit || fileCategoryLimit === 'signature') && clientName && msgType) && <Tab tabClassName={`details-tab tab-border file-manager-left ${!isDigitalSignSupported && 'file-manager-left-disabled'}`} className={`${styles['file-manager-tab']}`} eventKey='signature' title={`${t('signature')}`}>
                            {showFileContainers && fileManager.activeTab === 'signature' &&
                                <FilesContainer
                                    searchInput={fileManager.searchFielsInputValue}
                                    onSelectFile={onSelectFileHandler}
                                    tabKey={`signature`}
                                    fileCategory='signature'
                                    showSpinnerManagerState={showSpinnerManagerState}
                                    resetFileManager={resetFileManager}
                                    permissionType={permissionType}
                                    onAttachOneFileClicked={onAttachOneFileClickedHandler}
                                    fileTypesLimit={fileTypesLimit}
                                    clientName={clientName}
                                    contactName={contactName}
                                    msgType={msgType}
                                />}
                        </Tab>}
                    </Tabs>
                </Modal.Body>
                <Modal.Footer className={`${styles['file-manager-footer']}`}>
                    <div className={`${styles['model-footer-side']}`}>
                        <Button variant="primary" disabled={!activeTabSelectedFilesCount || !onAttachFilesClicked} onClick={onSendFilesClickedHandler} className={`btn-success ${styles['file-manager-btn-success']}`}>{t('attach all')}</Button>
                        <Button variant="primary" onClick={onUploadFileBtnClicked}>{t('Adding a files to the gallery')}</Button>
                        <Button variant="secondary" disabled={!onAttachFilesWithoutGalleryClicked} onClick={onlyAttachBtnClicked}>{t('Attach files without gallery')}</Button>
                        <Button variant="dark" className={`${styles['btn-add-container']} ${isCreateEncContainerDisabled && styles['btn-add-container-disabled']}`} onClick={onCreateFilesEncContainerHandler}>{t('Attach ecrypt files')}</Button>
                    </div>
                    <div className={`${styles['model-footer-side']}`}>
                        <Button variant="secondary" onClick={onHide}>{t('Exit')}</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <input
                // className={[styles.fileSelector]}
                type="file"
                accept={settings?.allSupportTypes}
                ref={fileExplorer}
                onChange={uploadfile}
                multiple="multiple"
                style={{ display: 'none' }}
            />
        </>
    )
}

export default FileManager